import { en } from './locales/en';
import { es } from './locales/es';


export const getLocate = (locate = '') => {
  return locate.includes('es') ? es : en; 
}